<template>
    <div class="Page">
        <Header Act="5"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <div class="AboutPos">
                    <span class="link" @click="back">当前位置：继续教育</span>
                    <span> / 项目详情</span>
                </div>

                <div v-if="detail" class="DetailWrap">
                    <div class="project-section">
                        <div class="section-title">课程信息</div>
                        <table class="info-table" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr>
                                    <th>课程名称</th>
                                    <td>{{ detail.title || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>项目编号</th>
                                    <td class="code">{{ detail.project_code || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>机构名称</th>
                                    <td>{{ detail.company_name || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>课程类型</th>
                                    <td>{{ detail.course_category_text || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>课程形式</th>
                                    <td>{{ detail.project_type_text || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>课程简介</th>
                                    <td class="intro">{{ detail.synopsis || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>联系人</th>
                                    <td>{{ detail.publish_contact || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else class="EmptyTip">{{ loading ? '加载中...' : '未找到该项目信息' }}</div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    export default {
        components: { Header, Footer },
        data() {
            return {
                detail: null,
                loading: true,
            }
        },
        mounted() {
            this.fetchDetail();
        },
        methods: {
            fetchDetail() {
                const id = this.$route.query.id;
                if (!id) {
                    this.loading = false;
                    return;
                }
                this.loading = true;
                this.$post("api/index/projectsDetail", { id }).then(res => {
                    if (res.data.code == 1) {
                        this.detail = res.data.data;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            back() {
                this.$router.push({ path: '/Education' });
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #f5f6f8;
        min-height: 100vh;
    }
    .MarTop {
        margin-top: 20px;
        margin-bottom: 40px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
    }
    .AboutPos .link{
        cursor: pointer;
        color: #0286eb;
    }
    .DetailWrap{
        padding-bottom: 20px;
    }
    .project-section{
        margin-top: 0;
        background: #fff;
        padding: 20px 24px 24px;
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    }
    .section-title{
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 16px;
        padding-left: 12px;
        border-left: 4px solid #409EFF;
        line-height: 1.2;
    }
    .info-table{
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #ebeef5;
        background: #fff;
        table-layout: fixed;
    }
    .info-table th,
    .info-table td{
        border: 1px solid #ebeef5;
        padding: 14px 16px;
        font-size: 14px;
        line-height: 1.7;
        vertical-align: top;
        word-break: break-all;
    }
    .info-table th{
        width: 140px;
        background: #f5f7fa;
        color: #606266;
        font-weight: 600;
        text-align: center;
    }
    .info-table td{
        color: #303133;
        background: #fff;
    }
    .info-table td.code{
        color: #d97706;
        font-weight: 600;
    }
    .info-table td.intro{
        white-space: pre-wrap;
        color: #555;
    }
    .EmptyTip{
        padding: 60px 0;
        text-align: center;
        color: #999;
        font-size: 15px;
        background: #fff;
        border-radius: 4px;
    }
    @media only screen and (max-width: 550px){
        .project-section{
            padding: 16px;
        }
        .info-table th{
            width: 96px;
            padding: 10px 8px;
            font-size: 13px;
        }
        .info-table td{
            padding: 10px 8px;
            font-size: 13px;
        }
    }
</style>
